import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse } from '../../../../Actions/AllAction';
import { withNamespaces } from 'react-i18next';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import CommonDateTimePicker from '../../../../Utility/Components/CommonDateTimePicker';
import Utility from '../../../../Utility/Utility';
import CustomInput from '../../../../Utility/Components/CustomInput';
import ValidateUtility from '../../../../Utility/ValidateUtility';
import parsePhoneNumber from 'libphonenumber-js';
import PhoneNumberWithCountryCode from '../../../../Utility/Components/PhoneNumberWithCountryCode';
import { Modal, Container, Alert } from 'react-bootstrap';
import ConfirmationAlert from '../../../../Utility/Components/ConfirmationAlert';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import { createDmcLead, createDmcNote } from '../Controller/HomeController';
import moment from 'moment';

function HotelBooking(props) {
    const { show, onHide, selectedRoom, selected_branch, userSearchDataFromReducer } = props;
    const history = useHistory();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [startDateError, setStartDateError] = useState('');
    const [endDateError, setEndDateError] = useState('');
    const [formData, setFormData] = useState({
        "name": "", "last_name": "", "phone_number": "", "email": "", "customer_gstin_no": ""
    });
    const [formDataError, setFormDataError] = useState({
        "name": "", "last_name": "", "phone_number": "", "email": "", "customer_gstin_no": ""
    });
    const [notes, setNotes] = useState("");
    const [notesError, setNotesError] = useState("");
    const [phoneNumberCountryCode, setPhoneNumberCountryCode] = useState("in");
    const [phoneNumberDialCode, setPhoneNumberDialCode] = useState("91");
    const [selectedCountryCode, setSelectedCountryCode] = useState("in");
    const [bookingCancellationModalFlag, setBookingCancellationModalFlag] = useState(false);
    const [numAdults, setNumAdults] = useState(userSearchDataFromReducer?.adult || 1);
    const [numChildren, setNumChildren] = useState(userSearchDataFromReducer?.children || 0);

    useEffect(() => {
        if (userSearchDataFromReducer?.start_date) {
            setStartDate(new Date(userSearchDataFromReducer.start_date));
        }
        if (userSearchDataFromReducer?.end_date) {
            setEndDate(new Date(userSearchDataFromReducer.end_date));
        }
    }, [userSearchDataFromReducer]);

    useEffect(() => {
        if (show) {
            setFormData({
                "name": "", "last_name": "", "phone_number": "", "email": "", "customer_gstin_no": ""
            });
            setFormDataError({
                "name": "", "last_name": "", "phone_number": "", "email": "", "customer_gstin_no": ""
            });
            setNotes("");
            setNotesError("");
            setBookingCancellationModalFlag(false);
            setNumAdults(userSearchDataFromReducer?.adult || 1);
            setNumChildren(userSearchDataFromReducer?.children || 0);
        }
    }, [show]);

    const getSelectedRoomList = () => {
        const list = [];
        Object.keys(selectedRoom || {}).forEach(roomTypeId => {
            Object.keys(selectedRoom[roomTypeId] || {}).forEach(rateId => {
                const room = selectedRoom[roomTypeId][rateId];
                if (room && room.value > 0) {
                    list.push({
                        room_type_name: room.room_type_name,
                        rate_plan: room.rate_plan || 'Standard Plan',
                        room_quantity: room.value,
                        price: room.total_room_price || 0,
                        currency: room.currency || '',
                        adults: numAdults,
                        children: numChildren,
                    });
                }
            });
        });
        return list;
    };

    const handelChangeDate = (date, field) => {
        if (field === 'start_date') {
            setStartDate(date);
            setStartDateError('');
        }
        if (field === 'end_date') {
            setEndDate(date);
            setEndDateError('');
        }
    };

    const incNumAdults = () => {
        setNumAdults((prev) => prev + 1);
    };

    const decNumAdults = () => {
        setNumAdults((prev) => (prev > 1 ? prev - 1 : 1));
    };

    const incNumChildren = () => {
        setNumChildren((prev) => prev + 1);
    };

    const decNumChildren = () => {
        setNumChildren((prev) => (prev > 0 ? prev - 1 : 0));
    };

    const isValidEmail = (email) => {
        const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return emailRegex.test(email);
    };

    const validateForm = () => {
        let isValid = true;
        let tempFormDataError = { ...formDataError };

        if ((formData.name).trim() == "") {
            isValid = false;
            tempFormDataError['name'] = "Required Field";
        }

        if ((formData.last_name).trim() == "") {
            isValid = false;
            tempFormDataError['last_name'] = "Required Field";
        }

        if (formData.email != "" && !isValidEmail(formData.email)) {
            isValid = false;
            tempFormDataError['email'] = "Enter valid email";
        }

        if (formData.phone_number == "" || formData.phone_number == null) {
            tempFormDataError['phone_number'] = "Required field";
            isValid = false;
        } else {
            let modifiedString = ValidateUtility.deleteAndBefore(formData.phone_number, phoneNumberDialCode);
            let countryCodeValue = phoneNumberCountryCode.toUpperCase();
            const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
            if (phoneNumber && phoneNumber.isValid()) {
                tempFormDataError['phone_number'] = "";
            } else {
                tempFormDataError['phone_number'] = "Enter valid contact number";
                isValid = false;
            }
        }

        if (formData.customer_gstin_no != "") {
            let gstnValidate = ValidateUtility.validate_gstn_Number(formData.customer_gstin_no);
            if (!gstnValidate) {
                isValid = false;
                tempFormDataError['customer_gstin_no'] = "Please enter a correct GSTIN No";
            }
        }

        setFormDataError(tempFormDataError);
        return isValid;
    };

    const handelChangeCustomerFn = (e, type, dialCodeObj = {}) => {
        let tempFormData = { ...formData };
        let tempFormDataError = { ...formDataError };

        if (type == "name") {
            var expr = /^[a-zA-Z ]*$/;
            if (expr.test(e.target.value)) {
                tempFormData["name"] = e.target.value;
                tempFormDataError['name'] = "";
            }
        }
        if (type == "last_name") {
            var expr = /^[a-zA-Z ]*$/;
            if (expr.test(e.target.value)) {
                tempFormData["last_name"] = e.target.value;
                tempFormDataError['last_name'] = "";
            }
        }
        if (type == "email") {
            tempFormData["email"] = e.target.value;
            if (e.target.value == "" || isValidEmail(e.target.value)) {
                tempFormDataError['email'] = "";
            } else {
                tempFormDataError['email'] = "Enter valid email";
            }
        }
        if (type == "customer_gstin_no") {
            tempFormData["customer_gstin_no"] = e.target.value;
            if (e.target.value == "" || ValidateUtility.validate_gstn_Number(e.target.value)) {
                tempFormDataError['customer_gstin_no'] = "";
            } else {
                tempFormDataError['customer_gstin_no'] = "Please enter a correct GSTIN No";
            }
        }
        if (type == "phone_number") {
            if (e.trim() !== "") {
                let modifiedString = ValidateUtility.deleteAndBefore(e, dialCodeObj.dialCode);
                let countryCodeValue = dialCodeObj.countryCode.toUpperCase();
                const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
                setPhoneNumberCountryCode(dialCodeObj.countryCode);
                setPhoneNumberDialCode(dialCodeObj.dialCode);
                if (phoneNumber && phoneNumber.isValid()) {
                    tempFormData["phone_number"] = e;
                    tempFormDataError['phone_number'] = "";
                } else {
                    tempFormData["phone_number"] = e;
                    tempFormDataError['phone_number'] = "Enter valid contact number";
                }
            } else {
                tempFormData["phone_number"] = "";
                tempFormDataError['phone_number'] = "Required field";
            }
        }
        if (type == "notes") {
            setNotes(e.target.value);
            setNotesError("");
        }

        setFormData(tempFormData);
        setFormDataError(tempFormDataError);
    };

    const submitDmcLead = () => {
        const customerEmail = formData.email || "";
        const customerPhone = formData.phone_number ? (formData.phone_number.includes("+") ? formData.phone_number : "+" + formData.phone_number) : "";
        const selectedRoomList = getSelectedRoomList();
        const payload = [{
            customer_name: `${formData.name || ""} ${formData.last_name || ""}`.trim(),
            customer_phone: customerPhone,
            stage_id: 1,
            branch_id: selected_branch?.branch_id || "",
            customer_email: customerEmail,
            org_id: selected_branch?.branch_full_details?.org_id || "",
            created_by: 0,
            source_id: "marketplace",
            lead_priority: "medium",
            remarks: notes || ""
        }];
        console.log("hotel payload========", payload);
        return createDmcLead(payload)
            .then((response) => {
                console.log("DMC lead created", response);
                const leadData = Array.isArray(response) ? response[0]?.data : response?.data;
                const leadId = leadData?.id;
                if (leadId) {
                    const phoneNumber = formData.phone_number ? formData.phone_number.replace(/\D/g, '').slice(-10) : "";
                    const selectedRoomListStr = selectedRoomList.length > 0 ? selectedRoomList[0] : {};
                    const notePayload = [{
                        customer_phone_number: phoneNumber,
                        content: "Hotel enquiry created successfully",
                        content_json: {
                            hotel_id: selected_branch?.hotel_property_id || "",
                            room_details: selectedRoomList,
                            branch_id: selected_branch?.branch_id || "",
                            org_id: selected_branch?.branch_full_details?.org_id || "",
                            start_date: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
                            end_date: endDate ? moment(endDate).format('YYYY-MM-DD') : "",
                            // rate_plan: selectedRoomListStr?.rate_plan || "",
                            // room_type_name: selectedRoomListStr?.room_type_name || "",
                            // room_quantity: selectedRoomListStr?.room_qty || "",
                        },
                        lead_id: leadId,
                        branch_id: selected_branch?.branch_id || "",
                        org_id: selected_branch?.branch_full_details?.org_id || ""
                    }];
                    return createDmcNote(notePayload)
                        .then((noteResponse) => {
                            console.log("DMC note created", noteResponse);
                            Utility.toastNotifications("Thank you for your enquiry. Your request has been submitted successfully. Our team will review it and share a quote with you shortly.", "Success", "success");
                            setBookingCancellationModalFlag(false);
                            onHide && onHide();
                            if (props.onBookingSuccess) props.onBookingSuccess();
                            history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/home`);
                        })
                        .catch((noteError) => {
                            console.error("DMC note error", noteError);
                        });
                }
            })
            .catch((error) => {
                console.error("DMC lead error", error);
            });
    };

    const confirmbookingConfirmButton = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        submitDmcLead().finally(() => {
            loaderStateFalse();
        });
    };

    const cancellationModalHide = () => {
        setBookingCancellationModalFlag(false);
    };

    const confirmbookingCancellationCancleButton = () => {
        setBookingCancellationModalFlag(false);
    };

    const paymentAndBookingFn = () => {
        if (selectedRoomList.length === 0) {
            Utility.toastNotifications("Please select at least one room.", "Warning", "warning");
            return false;
        }
        let valid = validateForm();
        if (!valid) {
            let pageBottom = document.querySelector('#page-bottom');
            if (pageBottom) pageBottom.scrollIntoView({ behavior: 'smooth' });
        } else {
            setBookingCancellationModalFlag(true);
        }
    };

    const selectedRoomList = getSelectedRoomList();

    if (!show) return null;

    return (
        <div className='dynamicGroupContainerBox'>
            <div className='dynamicGroupContainer bookingModalContentBox'>
                <div className='bookingModalContentBoxInner'>
                    <div className='rowCover'>
                        <div className='datePanel room-book-bx'>
                            <div className='rowCoverInner'>
                                <div className='row positionPanel multiRow borderBottom'>
                                    <div className='col-md-3'>
                                        <div className='datePickerBOX'>
                                            <label>Start Date</label>
                                            <ErrorBoundary title="CommonDateTimePicker Error">
                                                <CommonDateTimePicker
                                                    selected={startDate}
                                                    onChange={(e) => handelChangeDate(e, 'start_date')}
                                                    disabled={true}
                                                    showTimeSelect={false}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select date"
                                                    minDate={new Date()}
                                                    popperPlacement="bottom-end"
                                                    positionFixed
                                                    popperClassName="dateTime-picker-quatations-multiple"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </ErrorBoundary>
                                            {startDateError && <span className="text-danger">{startDateError}</span>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className='datePickerBOX'>
                                            <label>End Date</label>
                                            <ErrorBoundary title="CommonDateTimePicker Error">
                                                <CommonDateTimePicker
                                                    selected={endDate}
                                                    onChange={(e) => handelChangeDate(e, 'end_date')}
                                                    disabled={true}
                                                    showTimeSelect={false}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select date"
                                                    minDate={startDate}
                                                    popperPlacement="bottom-end"
                                                    positionFixed
                                                    popperClassName="dateTime-picker-quatations-multiple"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </ErrorBoundary>
                                            {endDateError && <span className="text-danger">{endDateError}</span>}
                                        </div>
                                    </div>

                                    <div className='col-md-6'>
                                        <div className='row'>
                                            <div className='roomBookfieldset'>
                                                <ul className='roomBookfieldsetul'>
                                                    <li className='adult-row'>
                                                        <div className='labelInputField'>
                                                            <div className='left-row-box left-row-label'>Adults</div>
                                                            <div className='right-row-box'>
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary btn-left" type="button" onClick={decNumAdults} disabled style={{ backgroundColor: "#EEF0F5", cursor: "no-drop" }}>-</button>
                                                                    </div>
                                                                    <input type="text" className="form-control" value={numAdults} disabled style={{
                                                                        backgroundColor: "#EEF0F5",
                                                                        cursor: "no-drop"
                                                                    }} />
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary btn-right" type="button" onClick={incNumAdults} disabled style={{ backgroundColor: "#EEF0F5", cursor: "no-drop" }}>+</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    <li className='childrenContainerBox child-row'>
                                                        <div className='labelInputField'>
                                                            <div className='left-row-box left-row-label'>Children</div>
                                                            <div className='right-row-box'>
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary btn-left" type="button" onClick={decNumChildren} disabled style={{ backgroundColor: "#EEF0F5", cursor: "no-drop" }}>-</button>
                                                                    </div>
                                                                    <input type="text" className="form-control" value={numChildren} disabled style={{
                                                                        backgroundColor: "#EEF0F5",
                                                                        cursor: "no-drop"
                                                                    }} />
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary btn-right" type="button" onClick={incNumChildren} disabled style={{ backgroundColor: "#EEF0F5", cursor: "no-drop" }}>+</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {selectedRoomList.length > 0 &&
                        <div className='row'>
                            <div className='col-md-12'>
                                <h3 className='modal-title-label'>Selected Rooms</h3>
                                <table className='table table-bordered selected-room-table'>
                                    <thead>
                                        <tr>
                                            <th>Room Type</th>
                                            <th>Rate Plan</th>
                                            <th>Qty</th>
                                            <th>Adults</th>
                                            <th>Children</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedRoomList.map((room, idx) => (
                                            <tr key={idx}>
                                                <td>{room.room_type_name}</td>
                                                <td>{room.rate_plan}</td>
                                                <td>{room.room_quantity}</td>
                                                <td>{room.adults}</td>
                                                <td>{room.children}</td>
                                                <td>{room.currency} {Number(room.price).toFixed(0)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }

                    <div className='row'>
                        <div className="col-md-12">
                            <ErrorBoundary title="CustomInput Error">
                                <CustomInput
                                    parentClassName="input_field_inner input_field_inner_note"
                                    labelName="Notes"
                                    errorLabel={notesError}
                                    name="notes"
                                    type="textarea"
                                    value={notes}
                                    labelPresent={true}
                                    requiredStar={false}
                                    onChange={(e) => handelChangeCustomerFn(e, 'notes')}
                                />
                            </ErrorBoundary>
                        </div>
                    </div>

                    <h3 className='modal-title-label'>Customer details</h3>
                    <div className='customerSecBox'>
                        <div className='paymentCustomerHotelPart relativeRow' id='page-bottom'>
                            <div className='row'>
                                <div className="col-md-3">
                                    <ErrorBoundary title="CustomInput Error">
                                        <CustomInput
                                            parentClassName="input_field_inner"
                                            labelName="First name"
                                            errorLabel={formDataError.name}
                                            name="branch_name"
                                            type="text"
                                            value={formData.name}
                                            labelPresent={true}
                                            onChange={(e) => handelChangeCustomerFn(e, 'name')}
                                        />
                                    </ErrorBoundary>
                                </div>
                                <div className="col-md-3">
                                    <ErrorBoundary title="CustomInput Error">
                                        <CustomInput
                                            parentClassName="input_field_inner"
                                            labelName="Last name"
                                            errorLabel={formDataError.last_name}
                                            name="last_name"
                                            type="text"
                                            value={formData.last_name}
                                            labelPresent={true}
                                            onChange={(e) => handelChangeCustomerFn(e, 'last_name')}
                                        />
                                    </ErrorBoundary>
                                </div>
                                <div className="col-md-3">
                                    <ErrorBoundary title="CustomInput Error">
                                        <PhoneNumberWithCountryCode
                                            title="Phone Number"
                                            country={selectedCountryCode}
                                            value={formData.phone_number}
                                            onChange={(e, country) => handelChangeCustomerFn(e, 'phone_number', country)}
                                            error={formDataError.phone_number}
                                            labelShow={true}
                                            requirStart={true}
                                            disableDropdown={false}
                                        />
                                    </ErrorBoundary>
                                </div>
                                <div className="col-md-3">
                                    <ErrorBoundary title="CustomInput Error">
                                        <CustomInput
                                            parentClassName="input_field_inner"
                                            labelName="Email"
                                            errorLabel={formDataError.email}
                                            name="email"
                                            type="text"
                                            value={formData.email}
                                            labelPresent={true}
                                            requiredStar={false}
                                            onChange={(e) => handelChangeCustomerFn(e, 'email')}
                                        />
                                    </ErrorBoundary>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-12 previewBtnContainer'>
                <button
                    className="btn btn-success previewSubBtn"
                    onClick={paymentAndBookingFn}
                    disabled={selectedRoomList.length === 0}
                >
                    Submit
                </button>
                <button className="btn btn-success previewCancelBtn" onClick={() => { setBookingCancellationModalFlag(false); onHide && onHide(); }}>Cancel</button>
            </div>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={bookingCancellationModalFlag}
                    onHide={cancellationModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Enquiry confirmation"
                    footer={false}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Would you like to proceed with this enquiry?"
                                    BodyThirdContent=""
                                    confirmationButtonContent="Confirm"
                                    cancelButtonContent="Cancel"
                                    deleteConfirmButton={confirmbookingConfirmButton}
                                    deleteCancleButton={confirmbookingCancellationCancleButton}
                                    deleteIconVissable={false}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

        </div>
    );
}

const mapStateToProps = (globalState) => ({
    userCredentials: globalState.LoginReducer.userCredentials,
});

export default connect(mapStateToProps, {
    loaderStateTrue,
    loaderStateFalse,
})(withNamespaces()(HotelBooking));
